import axios from "axios";

// function getStreetAddress(addressComponents) {
//   // Extract street-level details like street number, route, etc.
//   const streetNumber = addressComponents.find((comp) =>
//     comp.types.includes("street_number")
//   )?.long_name;

//   const route = addressComponents.find((comp) =>
//     comp.types.includes("route")
//   )?.long_name;

//   // Combine street number and route if both exist
//   if (streetNumber && route) {
//     return `${streetNumber} ${route}`;
//   }
//   // Return route or street number if only one exists
//   return route || streetNumber || null;
// }
const getStreetAddress = (components) => {
  const streetNumber = components.find((c) =>
    c.types.includes("street_number")
  )?.long_name;
  const route = components.find((c) => c.types.includes("route"))?.long_name;
  return [streetNumber, route].filter(Boolean).join(" ");
};

const GetAddressDetails = async (lat, lng) => {
  return new Promise((resolve, reject) => {
    if (!window.google || !window.google.maps) {
      reject("Google Maps JavaScript API not loaded");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    const latLng = { lat: parseFloat(lat), lng: parseFloat(lng) };

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        const addressComponents = results[0].address_components;

        const getComponent = (type) =>
          addressComponents.find((comp) => comp.types.includes(type))?.long_name;
        const getShort = (type) =>
          addressComponents.find((comp) => comp.types.includes(type))?.short_name;

        const streetAddress = getStreetAddress(addressComponents);
        const city =
          getComponent("administrative_area_level_3") ||
          getComponent("locality") ||
          getComponent("neighborhood") ||
          getComponent("political");
        const state = getComponent("administrative_area_level_1");
        const country = getComponent("country");
        const countryShort = getShort("country");
        // Keep in sync with backend `parseGeocodeComponents` in getDataByLatLng.js:
        // US → county (administrative_area_level_2); else prefer sublocality/neighborhood.
        const isUS =
          countryShort === "US" ||
          /^united states/i.test(country || "");
        let subAddress = "";
        if (isUS) {
          subAddress =
            getComponent("administrative_area_level_2") ||
            getComponent("sublocality") ||
            getComponent("neighborhood");
        } else {
          subAddress =
            getComponent("sublocality_level_2") ||
            getComponent("sublocality_level_1") ||
            getComponent("sublocality") ||
            getComponent("neighborhood") ||
            getComponent("administrative_area_level_2");
        }
        const zipcode = getComponent("postal_code");

        resolve({
          city,
          state,
          country,
          zipcode,
          subAddress,
          address: streetAddress || results[0].formatted_address,
        });
      } else {
        reject("Geocoder failed due to: " + status);
      }
    });
  });
};
// async function GetAddressDetails(lat, lng) {

//   const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; // Replace with your Google Maps API Key

//   const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

//   try {
//     const response = await axios.get(url);

//     if (response.data.status === "OK") {
//       const results = response.data.results;

//       if (results.length > 0) {
//         const addressComponents = results[0].address_components;


//         const streetAddress = getStreetAddress(addressComponents);

//         const subAddress = addressComponents.find((comp) => 
//           comp.types.includes("administrative_area_level_2")
//         )?.long_name;


//         const city = addressComponents.find((comp) =>
//           comp.types.includes("administrative_area_level_3")
//         )?.long_name || addressComponents.find((comp) =>  
//           comp.types.includes("locality"))?.long_name;

//         const state = addressComponents.find((comp) =>
//           comp.types.includes("administrative_area_level_1")
//         )?.long_name;

//         const country = addressComponents.find((comp) =>
//           comp.types.includes("country")
//         )?.long_name;

//         const zipcode = addressComponents.find((comp) =>
//           comp.types.includes("postal_code")
//         )?.long_name;


//         return {
//           city,
//           state,
//           country,
//           zipcode,
//           address: streetAddress || results[0].formatted_address, 
//           subAddress// Fallback to formatted address if streetAddress is not available
//         };
//       } else {
//         throw new Error("No results found");
//       }
//     } else {
//       throw new Error("Geocoding API error: " + response.data.status);
//     }
//   } catch (error) {
//     console.error("Error fetching geocode data:", error);
//     throw error;
//   }
// }

export default GetAddressDetails;
